import axios from "axios";
import { useAuthStore } from "@/store/authStore.ts";

const baseURL = import.meta.env.VITE_API_HOST;

const LOGIN_PATH = "/login";

// SDCP-1281: discard any persisted token that doesn't look like a real
// three-part JWT. Stale/corrupted localStorage was leaving the app sending
// junk Bearer tokens, then surfacing the BE's "jwt malformed" library text
// in the Sizing Tool UI until the user manually cleared their cache.
const persistedToken = useAuthStore.getState().token;
if (persistedToken && persistedToken.split(".").length !== 3) {
  useAuthStore.getState().reset();
}

const authApi = axios.create({
  baseURL,
});

authApi.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  config.headers.Authorization = `Bearer ${token}`;

  // REMOVE NEXT LINE, ONLY FOR DEV MODE
  config.headers["ngrok-skip-browser-warning"] = "69420";

  return config;
});

authApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // SDCP-1281: on any 401, clear the bad token AND hard-redirect to
    // /login so the calling mutation never gets to render the BE error
    // text under a form field (the original Sizing-Tool symptom).
    // Use window.location.replace so in-memory state, TanStack-Query
    // caches and any pending mutations are wiped — no stale data leaks
    // between sessions. Skip the redirect if we're already on /login,
    // otherwise a 401 from the login endpoint itself would loop.
    if (error.response && error.response.status === 401) {
      useAuthStore.getState().reset();
      if (
        typeof window !== "undefined" &&
        window.location.pathname !== LOGIN_PATH
      ) {
        window.location.replace(LOGIN_PATH);
      }
    }

    return Promise.reject(error);
  }
);

export default authApi;
